import React, { useState, useEffect } from 'react';
import './DriverSegmentationPage.css';
import DriversSegmentation from '../../components/DriversSegmentation/DriversSegmentation';
import DriverScoreCategoryPage from '../DriverScoreCategoryPage/DriverScoreCategoryPage';
import { getVehicleTypes } from '../../api/apiClient';
import tooltipTexts from '../../utils/tooltipTexts';

function DriverSegmentationPage() {
  const [selectedVehicleId, setSelectedVehicleId] = useState('');
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [vehicleError, setVehicleError] = useState(null);

  useEffect(() => {
    // Get admin location from localStorage and fetch vehicles
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.locationId) {
      fetchVehicleTypes(user.locationId);
    } else {
      setIsLoading(false);
      setVehicleError('No location ID found for admin');
      console.error('No location ID found for admin');
    }
  }, []);

  const fetchVehicleTypes = async (locationId) => {
    setIsLoading(true);
    setVehicleError(null);
    setVehicleTypes([]);
    
    try {
      console.log(`Fetching vehicles for location ID: ${locationId}`);
      const data = await getVehicleTypes(locationId);
      
      console.log(`Received vehicles for location ${locationId}:`, data);
      
      if (data.length === 0) {
        setVehicleError('No vehicles available for your location');
      } else {
        setVehicleTypes(data);
        // Set the first vehicle as selected by default
        if (data.length > 0) {
          setSelectedVehicleId(data[0].VehicleID.toString());
        }
      }
    } catch (error) {
      console.error('Error fetching vehicle types:', error);
      setVehicleError('Failed to load vehicles for your location');
    } finally {
      setIsLoading(false);
    }
  };

  const handleVehicleChange = (e) => {
    const newVehicleId = e.target.value;
    console.log("Selected vehicle changed to:", newVehicleId);
    setSelectedVehicleId(newVehicleId);
  };

  return (
    <div className="driver-segmentation-content">
      <div className="page-title">
        <h2>
          Driver Segmentation
          <span className="header-tooltip">
            <span className="info-icon">i</span>
            <span className="tooltip-text">{tooltipTexts.driverSegmentationHeader}</span>
          </span>
        </h2>
        <div className="equipment-dropdown-container">
          <span className="dropdown-label">Equipment:</span>
          <div className="equipment-dropdown">
            <select 
              id="vehicle-select"
              value={selectedVehicleId} 
              onChange={handleVehicleChange}
              disabled={isLoading}
              className="vehicle-select"
            >
              {isLoading ? (
                <option>Loading...</option>
              ) : vehicleError ? (
                <option value="">{vehicleError}</option>
              ) : vehicleTypes.length === 0 ? (
                <option value="">No equipment available</option>
              ) : (
                vehicleTypes.map(vehicle => (
                  <option key={vehicle.VehicleID} value={vehicle.VehicleID.toString()}>
                    {vehicle.ScreenName || vehicle.VehicleName || `Vehicle ${vehicle.VehicleID}`}
                  </option>
                ))
              )}
            </select>
          </div>
        </div>
      </div>
      
      <div className="segmentation-section">
        <div className="segmentation-container">
          <DriversSegmentation vehicleId={selectedVehicleId} disableNavigation={true} />
        </div>
      </div>
      
      <div className="score-category-section">
        <DriverScoreCategoryPage vehicleId={selectedVehicleId} embedded={true} />
      </div>
    </div>
  );
}

export default DriverSegmentationPage; 